import classNames from 'classnames';
import { FC, ReactNode } from 'react';

export interface ILabelTitleSubtitle {
  title: ReactNode;
  subtitle?: ReactNode;
  disabled?: boolean;
}

export const LabelTitleSubtitle: FC<ILabelTitleSubtitle> = (props) => {
  const { title, subtitle, disabled } = props;

  return (
    <div className="w-full">
      <div
        className={classNames(
          'text-p2',
          disabled ? 'text-grayv2-300' : 'text-grayv2-900',
        )}
      >
        {title}
      </div>
      <div
        className={classNames(
          'text-p1',
          disabled ? 'text-grayv2-300' : 'text-grayv2-500',
        )}
      >
        {subtitle}
      </div>
    </div>
  );
};
